import { type ReactNode, createContext, useState } from 'react';
import { type GlobalSettingsContextType } from '@/types/globalSettings.type';
import { type ScopeListedItem } from '@/types';

const defaultGlobalSettingsContext: GlobalSettingsContextType = {
  currentChurch: null,
  setCurrentChurch: () => {
    console.warn('setCurrentChurch called outside GlobalSettingsProvider');
  },
};

const GlobalSettingsContext = createContext(defaultGlobalSettingsContext);

export { GlobalSettingsContext };

export const GlobalSettingsProvider = ({ children }: { children: ReactNode | ReactNode[] }) => {
  const [currentChurch, setCurrentChurch] = useState<ScopeListedItem | null>(null);
  return (
    <GlobalSettingsContext.Provider value={{ currentChurch, setCurrentChurch }}>
      {children}
    </GlobalSettingsContext.Provider>
  );
};
